function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "82",
  height: "64",
  viewBox: "0 0 82 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M79.379 18.301a8.095 8.095 0 00-5.724-9.914L50.198 2.102a8.095 8.095 0 00-9.914 5.724l-9.951 37.14a8.095 8.095 0 005.723 9.914l23.457 6.285a8.095 8.095 0 009.914-5.724l9.952-37.14z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.15 6.012l23.457 6.285a4.047 4.047 0 012.862 4.957l-9.951 37.14a4.047 4.047 0 01-4.957 2.861L37.104 50.97a4.047 4.047 0 01-2.862-4.957l9.952-37.14a4.047 4.047 0 014.956-2.861zm24.505 2.375a8.095 8.095 0 015.724 9.914l-9.952 37.14a8.095 8.095 0 01-9.914 5.724L36.056 54.88a8.095 8.095 0 01-5.723-9.914l9.951-37.14a8.095 8.095 0 019.914-5.724l23.457 6.285z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 8.148C23 3.648 26.582 0 31 0h24c4.418 0 8 3.648 8 8.148v38.704c0 4.5-3.582 8.148-8 8.148H31c-4.418 0-8-3.648-8-8.148V8.148z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55 4.074H31c-2.21 0-4 1.824-4 4.074v38.704c0 2.25 1.79 4.074 4 4.074h24c2.21 0 4-1.824 4-4.074V8.148c0-2.25-1.79-4.074-4-4.074zM31 0c-4.418 0-8 3.648-8 8.148v38.704c0 4.5 3.582 8.148 8 8.148h24c4.418 0 8-3.648 8-8.148V8.148C63 3.648 59.418 0 55 0H31z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.621 18.301a8.095 8.095 0 015.724-9.914l23.457-6.285a8.095 8.095 0 019.914 5.724l9.951 37.14a8.095 8.095 0 01-5.723 9.914l-23.457 6.285a8.095 8.095 0 01-9.914-5.724l-9.952-37.14z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.85 6.012L9.392 12.297a4.047 4.047 0 00-2.862 4.957l9.952 37.14a4.047 4.047 0 004.956 2.861l23.457-6.285a4.047 4.047 0 002.862-4.957l-9.952-37.14a4.047 4.047 0 00-4.956-2.861zM8.345 8.387a8.095 8.095 0 00-5.724 9.914l9.952 37.14a8.095 8.095 0 009.914 5.724l23.457-6.285a8.095 8.095 0 005.723-9.914l-9.951-37.14a8.095 8.095 0 00-9.914-5.724L8.345 8.387z",
  fill: "#fff"
})));